import React, { FC, useState, useEffect, useContext } from "react";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Space from "antd/lib/space";
import { ReactComponent as InboundIcon } from "../../icons/inbound.svg";
import { ReactComponent as OutboundIcon } from "../../icons/outbound.svg";
import { ReactComponent as AgentIcon } from "../../icons/agent.svg";
import { ReactComponent as PhoneIcon } from "../../icons/phone.svg";
import moment from "moment";
import { NoteHistoryContext } from "../../contexts/noteHistory";
import {
  StyledContainer,
  StyledNoteContainer,
  StyledNote,
  StyledIconWrapper,
  StyledContentWrapper,
} from "./styledComponents";

const NoteHistory: FC = () => {
  const { noteHistory } = useContext(NoteHistoryContext);

  const icon = (endpoint: string) => {
    if (endpoint === "N/A") {
      return <PhoneIcon style={{ fontSize: "18px" }} />;
    } else if (endpoint === "inbound") {
      return <InboundIcon style={{ fontSize: "18px" }} />;
    }
    return <OutboundIcon style={{ fontSize: "18px" }} />;
  };

  return (
    <StyledContainer>
      {noteHistory.map((n, index) => {
        const noteObject = JSON.parse(n.contactNotes);
        const time = moment(n.timestamp).format("llll");
        return (
          <StyledNoteContainer key={index}>
            <Row>
              <Col span={12} style={{ paddingTop: "8px" }}>
                <div className="subject">{noteObject.subject}</div>
                <div className="header">{time}</div>
              </Col>
              <Col span={6} className="paddingTop header">
                <Space>
                  <StyledIconWrapper>
                    <AgentIcon style={{ fontSize: "18px" }} />
                  </StyledIconWrapper>
                  <StyledContentWrapper>{n.agentName}</StyledContentWrapper>
                </Space>
              </Col>
              <Col span={6} className="paddingTop header alignPaddingLeft">
                <Space>
                  <StyledIconWrapper>{icon(n.endpointType)}</StyledIconWrapper>
                  <StyledContentWrapper>{n.queueName}</StyledContentWrapper>
                </Space>
              </Col>
            </Row>
            <Row style={{ paddingTop: "8px" }}>
              <StyledNote span={24}>{noteObject.note}</StyledNote>
            </Row>
          </StyledNoteContainer>
        );
      })}
    </StyledContainer>
  );
};

export default NoteHistory;
